import * as m from 'mithril';
import LoadingIndicator from "../../components/LoadingIndicator";
import AppContext from '../../context/AppContext';
import CustomSvgIcon from '../../components/CustomSvgIcon';
import { MoneyDTO, SeatDTO, SeatPlanCellDTO, SeatPlanDTO } from '../../apiclient/ApiDtos';

interface SeatComponentAttrs {
    seatCell: SeatPlanCellDTO,
    hidePricePopAnimation: boolean,
    shouldShake: boolean,
    isSelected: boolean,
    isMultipleSeatPriceTrip: boolean,
    onClick: () => void;
}

let usdFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
});

let mmkFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'MMK',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
});

//TODO
let formatMoney = (money: MoneyDTO) => {
    if (money.currency == "MMK") {
        return mmkFormatter.format(money.amount);
    } else if (money.currency == "USD") {
        return usdFormatter.format(money.amount);
    }
    return "N/A";
}
function SeatComponent(): m.Component<SeatComponentAttrs> {
    return {
        view(vnode) {
            let seatFeatureClass = "";
            if (vnode.attrs.seatCell.isSeat && vnode.attrs.seatCell.seat) {
                if (
                    vnode.attrs.seatCell.seat.priceLevel.max >= 3 &&
                    vnode.attrs.seatCell.seat.priceLevel.value == 1
                ) {
                    seatFeatureClass = "seat-price-lowest";
                } else if (
                    vnode.attrs.seatCell.seat.priceLevel.max >= 3 &&
                    vnode.attrs.seatCell.seat.priceLevel.value == vnode.attrs.seatCell.seat.priceLevel.max
                ) {
                    seatFeatureClass = "seat-price-highest";
                } else if (
                    vnode.attrs.seatCell.seat.priceLevel.max >= 2 &&
                    vnode.attrs.seatCell.seat.priceLevel.value == vnode.attrs.seatCell.seat.priceLevel.max
                ) {
                    seatFeatureClass = "seat-price-highest";
                } else {
                    seatFeatureClass = "seat-price-normal";
                }

                if (vnode.attrs.isSelected) {
                    seatFeatureClass += " seat-selected";

                    if (vnode.attrs.shouldShake) {
                        seatFeatureClass += " shake"
                    }
                }
            }

            if (vnode.attrs.seatCell.isSeat && vnode.attrs.seatCell.seat?.isAvailable) {
                return m("a", {
                    class: "seat seat-available " + seatFeatureClass,
                    href: "#",
                    onclick: (event) => {
                        event.preventDefault();
                        vnode.attrs.onClick();
                    }
                },
                    m("span.en-only", { class: (vnode.attrs.isSelected) ? "" : "", style: "min-width: 35px;" }, vnode.attrs.seatCell.seat.number),
                    vnode.attrs.isSelected && vnode.attrs.isMultipleSeatPriceTrip && !vnode.attrs.hidePricePopAnimation ? m("div.price-pop", {
                        style: `
                            position: absolute;
                            bottom: 100%;
                            left: 50%;
                            transform: translateX(-50%) translateY(0) scale(0.8);
                            padding: 6px 10px;
                            background: #ffc107;
                            color: #000;
                            font-weight: bold;
                            border-radius: 8px;
                            font-size: 12px;
                            white-space: nowrap;
                            opacity: 1;
                            pointer-events: none;
                            z-index: 100;
                            animation: pricePopAnimation 3.5s forwards;
                        `
                    }, `${formatMoney(vnode.attrs.seatCell.seat.price)}`) : null
                );
            } else {
                return m("a", { class: "seat seat-unavailable" }, m("span.en-only", { style: "min-width: 35px;" }, vnode.attrs.seatCell.seat?.number));
            }
        }
    }
}


interface BusLayoutComponentAttrs {
    appContext: AppContext,
    hidePricePopAnimation: boolean,
    isDirectBookableTrip: boolean,
    isMultipleSeatPriceTrip: boolean,
    seatPlan: SeatPlanDTO,
    seatSelections: SeatDTO[],
    requiredSeatCount: number,
    isSubmittingSeatReservation: boolean,
    onSeatReservationRequested: (seats: SeatDTO[]) => void,
    onUnselectSeat: (seat: SeatDTO) => void,
    onSelectSeat: (col: SeatDTO) => void
}


function BusLayoutComponent(): m.Component<BusLayoutComponentAttrs> {
    let isLoading: boolean = false;
    let isSubmittingSeatSelections: boolean = false;
    let seatSelections: SeatDTO[] = [];
    let selectedSeatIds: string[] = [];
    let isSeatSelectionLimitReached = false;

    return {
        oninit(vnode) {
        },
        view(vnode) {
            const { appContext, seatPlan, requiredSeatCount, isDirectBookableTrip } = vnode.attrs;
            isSubmittingSeatSelections = vnode.attrs.isSubmittingSeatReservation;
            seatSelections = vnode.attrs.seatSelections;
            selectedSeatIds = seatSelections.map(seat => seat.id);
            let totalSeatPriceCurrency = "MMK";
            let totalSelectedSeatsPrice = seatSelections.reduce((total, seat) => (total + seat.price.amount), 0);

            console.debug("NeedtoSelectSeats: ", requiredSeatCount - seatSelections.length)
            console.debug("SeatSelection: ", seatSelections)
            return m("div", [
                m("div",
                    m("div", {},
                        (isLoading) ? m("div.col", {}, m(LoadingIndicator, {})) :
                            [
                                m("div", [
                                    (!isDirectBookableTrip) ?
                                        m("div.mt-1",
                                            m("span.small important-info-alert", appContext.getMessageProvider().get("small_car.non_direct_booking_warning"))
                                        )
                                        : null,

                                    m("div.driver-seat text-muted", { id: "cart-icon" }, "Driver"),
                                    m("table", { class: "table table-seat-plan" },
                                        m("tbody", {},
                                            seatPlan.grid.map(
                                                seatRowArr => {
                                                    return m("tr", {},
                                                        seatRowArr.map(function (col) {
                                                            if (col && col.isSeat && col.seat) {
                                                                return m("td.border-0",
                                                                    m(SeatComponent, {
                                                                        seatCell: col,
                                                                        hidePricePopAnimation: vnode.attrs.hidePricePopAnimation,
                                                                        shouldShake: isSeatSelectionLimitReached,
                                                                        isSelected: selectedSeatIds.includes(col.seat.id),
                                                                        isMultipleSeatPriceTrip: vnode.attrs.isMultipleSeatPriceTrip,
                                                                        onClick: () => {
                                                                            if (!selectedSeatIds.includes(col.seat?.id!)) {
                                                                                if (selectedSeatIds.length < requiredSeatCount) {
                                                                                    vnode.attrs.onSelectSeat(col.seat!);
                                                                                } else {
                                                                                    isSeatSelectionLimitReached = true;

                                                                                    setTimeout(() => {
                                                                                        isSeatSelectionLimitReached = false;
                                                                                        m.redraw();
                                                                                    }, 1000 * 1.5); // 1.5s 
                                                                                }
                                                                            } else {
                                                                                vnode.attrs.onUnselectSeat(col.seat!);
                                                                                isSeatSelectionLimitReached = false;
                                                                            }
                                                                        }
                                                                    }));
                                                            } else {
                                                                return m("td.border-0", {}, m("span.aisle"));
                                                            }
                                                        })
                                                    );
                                                }
                                            )
                                        )
                                    ),
                                    m("div#overlay_el_alskdfjalsdj", {
                                        class: "fly-overlay"
                                    })
                                ])
                            ]),



                    m("div.fixed-bottom",

                        m("div.d-none", { class: "card card-elevated-1" },


                            m("div.card-body px-3 py-2", [
                                m("div.small font-weight-bold fw-bold text-muted my-2 text-label-primary-light",
                                    requiredSeatCount > 1 ?
                                        appContext.getMessageProvider().get("seat_selection.select_n_seats", {
                                            numOfSeats: requiredSeatCount
                                        }) :

                                        appContext.getMessageProvider().get("seat_selection.select_one_seat")
                                ),
                                seatSelections.map(function (seat) {
                                    return m("div.row my-2",
                                        m("div.col-5",
                                            m("span", { class: "seat-selection-slot en-only mr-2" }, seat.number)
                                        ),
                                        m("div.col-7.text-right",
                                            m("span", { class: "text-dark" }, (seat.price.currency + " " + seat.price.amount))
                                        ),
                                    )
                                }),
                                requiredSeatCount - seatSelections.length > 0 ?
                                    Array.from({ length: requiredSeatCount - seatSelections.length }, (_, index) =>
                                        m("div.row my-2",
                                            m("div.col-5",
                                                m(
                                                    "span",
                                                    {
                                                        key: index,
                                                        class: "seat-selection-slot en-only mr-2",
                                                    }
                                                )
                                            ),
                                            m("div.col-7")
                                        )
                                    ) : null,
                                seatSelections.length > 0 ?
                                    m("div.row mt-3 mb-2",
                                        m("div.col-5",
                                            m("span", { class: "small mr-2" }, appContext.getMessageProvider().get("total_seat_price"))
                                        ),
                                        m("div.col-7.text-right",
                                            m("span", { class: "text-success font-weight-bold fw-bold" },
                                                seatSelections.length > 0 ?
                                                    (totalSeatPriceCurrency + " " + totalSelectedSeatsPrice)
                                                    : null
                                            )
                                        ),
                                    ) : null,
                                m("div", {
                                    class: "row"
                                }, [
                                    m("div", { class: "col text-right" },
                                        isSubmittingSeatSelections ?
                                            m("button", {
                                                class: "btn disabled btn-primary text-nowrap form-control"
                                            },
                                                appContext.getMessageProvider().get("seat_selection.submitting")
                                            ) :
                                            m("button", {
                                                class: "btn btn-primary text-nowrap form-control",
                                                disabled: (seatSelections.length == requiredSeatCount) ? false : true,
                                                onclick: (event) => {
                                                    event.preventDefault();

                                                    if (seatSelections.length == requiredSeatCount) {
                                                        let selectedSeats: SeatDTO[] = seatSelections;
                                                        vnode.attrs.onSeatReservationRequested(selectedSeats);
                                                    }
                                                }
                                            },
                                                appContext.getMessageProvider().get("seat_selection.submit")
                                            )
                                    )
                                ]),
                            ]
                            ),
                            appContext.isLeavingExtraMarginBottom() ?
                                m("div.app-area-system-nav") : null
                        ),

                    )
                )
            ]);
        }
    }
}

export default BusLayoutComponent;